import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';

export default class SendPayLink extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            source: props.Source,
            sourceId: props.SourceId,
            organizationId: props.OrganizationId,
            data: null,
            link: '',
            loading: true,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost('api/v1/common/makepaylink', {
            organizationId: this.state.organizationId,
            source: this.state.source,
            sourceId: this.state.sourceId,
        }).then((data) => {
            if (data.status === -1) window.location.href = '/login';
            if (data.status === 1) {
                this.state.link = data.link;
            } else {
                this.showErorrMessage(data.message);
            }
            this.setState({
                loading: false,
            });
        });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">لینک پرداخت آنلاین</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <p className="mt-2">لینک آنلاین جهت واریز وجه:</p>
                                <p style={{ "direction": "ltr", "textAlign": "left" }}><a target="_blank" href={this.state.link}>{this.state.link}</a></p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>بستن</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}